<template>
    <section class="pda-default">
        <!-- {{chatroomList}} -->
        <no-data v-if="isNoData"></no-data>

        <div class="learn-question-card" v-else>
            <div class="mdc-card mdc-elevation--z2 pda-default" v-for="(chatroom, index) in chatroomList" :key="index" :class="{'mgt-16': index > 0}"  @click="moveQuestion(chatroom)">
                <div class="t-body1">
                    {{chatroom.title}}
                </div>
                <div class="t-body3 d-flex justify-content-between mgt-16 mgl-16 mgr-16">
                    <div class="count">
                        <div class="t-headline9 box my">
                            {{chatroom.me}}
                        </div>
                        <div class="t-color-content1 mgt-4">
                            {{$t('117')}}
                            <!-- 나의 질문 -->
                        </div>
                    </div>
                    <div class="count">
                        <div class="t-headline9 box teacher" :class="{'on': chatroom.newTeacher}">
                            {{chatroom.teacher}}
                        </div>
                        <div class="t-color-content1 mgt-4">
                            {{$t('118')}}
                            <!-- 강사 답변 -->
                            <div class="dot" v-if="chatroom.newTeacher"></div>
                        </div>
                    </div>
                    <div class="count">
                        <div class="t-headline9 box friend" :class="{'on': chatroom.newOther}">
                            {{chatroom.other}}
                        </div>
                        <div class="t-color-content1 mgt-4 position-relative">
                            {{$t('119')}}
                            <!-- 동료 질문 -->
                            <div class="dot" v-if="chatroom.newOther"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        
        <transition name="slide">
            <router-view></router-view>
        </transition>
        
    </section>
    
</template>

<script>
/**
 * 나의 학습 상세 - 질문하기 탭 컴포넌트(my learning view - question tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import NoData from '../../common/NoData.vue'
import learnApi from '@/api/learnApi.js'

export default {
    components: {
        'no-data': NoData
    },

    data() {
        return {
            isNoData: false,
            chatroomList: []
        }
    },

    mounted() {
        const ripples = [].map.call(document.querySelectorAll('.purchase-item'), function(el) {
            let ripple = new MDCRipple.attachTo(el)
            return ripple
        })

        let params = this.setParams()
        
        // 채팅 룸 정보(get chatting room list)
        learnApi.learnChatroomList(params).then((response) => {
            this.chatroomList = response.data.data.content
            
            if (!this.chatroomList.length) {
                this.isNoData = true
            }

        }).catch((err) => {
            
        })
    },

    methods: {
        // move question
        moveQuestion(chatroom) {
            //console.log(id);
            this.$router.push({
                name: 'LearnViewQuestion',
                params: {lessonId: chatroom.lessonId}
            })
            
        },

        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                size: 100,
                learnId: this.$route.params.learnId
            }
            return params
        },
    }

}
</script>